import { Transmit } from '@adonisjs/transmit-client'
import Cookies from 'js-cookie'

function injectAuthHeader(request: RequestInit) {
    const token = Cookies.get('JWT')
    if (!token) return

    if (request.headers instanceof Headers) {
        request.headers.set('Authorization', `Bearer ${token}`)
    } else {
        request.headers = {
            ...(request.headers as Record<string, string>),
            Authorization: `Bearer ${token}`,
        }
    }
}

export const transmit = new Transmit({
    baseUrl: import.meta.env.VITE_BASE_URL,
    beforeSubscribe: injectAuthHeader,
    beforeUnsubscribe: injectAuthHeader,
})
